import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import ru from 'vuetify/es5/locale/ru'

const moment = require('moment')
moment.locale('ru')

Vue.filter(
  'date_time', function (value) {
    if (!value) return ''
    return moment(value).format('DD.MM.YYYY HH:mm:ss')
  }
)
Vue.filter(
  'short_date', function (value) {
    if (!value) return ''
    return moment(value).format('DD.MM.YYYY')
  }
)
Vue.filter(
  'period_date', function (value) {
    if (!value) return ''
    return moment(value).format('MMMM YYYY')
  }
)
Vue.filter('snils', function (snils) {
  // Example: 12345678910 => 123-456-789 10
  let clearSnils = ('' + snils).replace(/[^0-9]/g, '')
  return clearSnils.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1-$2-$3 $4')
})

Vue.use(Vuetify)

export default new Vuetify({
  // theme: {
  //   themes: {
  //     light: {
  //       primary: '#3f51b5',
  //       secondary: '#424242',
  //       accent: '#82B1FF',
  //       error: '#FF5252',
  //       info: '#2196F3',
  //       success: '#4CAF50',
  //       warning: '#FFC107'
  //     }
  //   }
  // },
  lang: {
    locales: { ru },
    current: 'ru'
  }
})
